import React from 'react';

/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  l,
  f,
  BoxC,
  BtnC,
  GridC,
  IptC,
  TextC,
  TblC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as BtnC from "./_cccBtnC";
import * as TblC from "./_ccmTblC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as l from "./_csLcl"; // 廃止予定
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';

import * as icvI17_Mz from './icvI17___Mz';


let $i17rs = [] as ht.ls;
let $i17rRz = {} as ht.dz;

export const T = (pz: {
  boxStlz?: ht.boxStlz,
  sPz: ht.dz,
  cz: {
    bEdit: ht.b,
    bFee: ht.b,
    i1zz: ht.dz,
    _31r_fst: ht.n,
    clr: ht.s,
    bMplDay: ht.b,
    i18r_fst: ht.n,
  }
}) => {

  const _udtThis = l.udtThis();

  const _udtI1z2s = async () => {
/*
    hf.udtDz(pz.cz.i1zz.i1z3z, icm.grtI1z3z({
      i1zz: pz.cz.i1zz,
      i17rs: $i17rs,
    }));
*/
    icm.udtI1z3z({
      i1zz: pz.cz.i1zz,
      i17rs: $i17rs,
    });
    pz.sPz.udtAll();
  };

  React.useEffect(() => {
    cmFTH.loadAllAsync({
      frcUdt: _udtThis,
      bfrAsync: () => [
        icvI17_Mz.loadI17rLsAsync({
          _31r_fst: pz.cz._31r_fst,
          i18r_fst: pz.cz.i18r_fst,
        })
        .then( (_ls: ht.ls) => {
          $i17rs = _ls;
        }),
      ]
    })
  }, [])

  React.useEffect(() => {
    if (pz.cz.bMplDay != true) { // 単数日選択の場合
      icvI17_Mz.loadI17rRzAsync({
        _31r_fst: pz.cz._31r_fst,
        i1zrd3100s: pz.cz.i1zz.i1zrz.i1zrd3100s,
        i1zrs1100iMnm: 70,
        i1z2a1100i: pz.cz.i1zz.i1zrz.i1zrd4100i,
        i1z2a1200i: pz.cz.i1zz.i1zrz.i1zrd4200i,
      })
      .then((_rz: ht.dz) => {
        $i17rRz = _rz;
        _udtThis();
      });
    }
  }, [
    pz.cz.i1zz.i1zrz.i1zrd3100s,
    pz.cz.i1zz.i1zrz.i1zrd4100i,
    pz.cz.i1zz.i1zrz.i1zrd4200i,
  ])

  React.useEffect(() => {
    //hf.l(`icvI17_Tz 63: ${pz.cz.i1zz.i1zrz.i1zrd3100s}, ${pz.cz.i1zz.i1zrz.i1zrd4100i}, ${pz.cz.i1zz.i1zrz.i1zrd4200i}`);
    //hf.l(`icvI17___Tz: ${ihd.nd(pz.cz.i1zz.i1z1s).length}`);
    if (pz.cz.bMplDay) { // 複数日選択の場合
      $i17rRz = {} as ht.dz; 
      hf.ectSrlAsync(
        icm.getI1z1Atv(pz.cz.i1zz.i1z1s)
        .map((_i1z1z: ht.dz) => async () => {
          const _rz = await icvI17_Mz.loadI17rRzAsync({
            _31r_fst: pz.cz._31r_fst,
            i1zrd3100s: _i1z1z.i1z1d1100s,
            i1zrs1100iMnm: 70,
            i1z2a1100i: _i1z1z.i1z1a1100i,
            i1z2a1200i: _i1z1z.i1z1a1200i,
          }) as ht.dz;
          Object.keys(_rz).map((_i17r_fst: ht.s) => {
            if (!$i17rRz[_i17r_fst]) $i17rRz[_i17r_fst] = _rz[_i17r_fst];
            if ($i17rRz[_i17r_fst].rmn > _rz[_i17r_fst].rmn) $i17rRz[_i17r_fst] = _rz[_i17r_fst];
          });
          return true;
        })
      )
      .then(() => {
        _udtThis();
      });
    }
  }, [
    icm.getI1z1Atv(pz.cz.i1zz.i1z1s).length,
  ])

  const _hdrs = [] as ht.ls;

  _hdrs.push(
    {
      cellCs: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '備品・駐車場',
                stlz: a(`tc/${pz.cz.clr}7`),
              }
            })
          ]
        },
        {
          boxStlz: a(`f/0.5`),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '残数',
                stlz: a(`tc/${pz.cz.clr}7`)
              }
            })
          ]
        },
        pz.cz.bFee != false ?
        {
          boxStlz: a(`f/0.5`),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用料',
                stlz: a(`tc/${pz.cz.clr}7`)
              }
            })
          ]
        }
        : null,
        pz.cz.bEdit != false ?
        {
          boxStlz: a('dw/btn f/n'),
          oClds: [
          ]
        }
        : null,
      ]
    }
  );

  const _rowCs = [] as ht.ls;

  //hf.l(`icvI17_Tz 139: ${hf.s($i17rRz)}`)
  pz.cz.i1zz.i1z2s.filter(( _i1z2z: ht.dz ) => _i1z2z._dlt != 1).map( ( _i1z2z: ht.dz, _nIdx: ht.n ) => {
  //hf.l(`icvI17_Tz 141: ${_i1z2z.i1z2i17r1f}, ${hf.s(_i1z2z)}`)
    _rowCs.push({
      //boxStlz: a('mb/0.5'),
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, { // 備品・設備
              key: _nIdx,
              cz: {
                bEdit: pz.cz.bEdit,
                iptType: 'pcr',
                ls: $i17rs,
                vle: _i1z2z.i1z2i17r1f,
                onChg: ( _dz: ht.dz ) => {
                  const _dz2 = icm.grtI1z2z({
                    i17r_fst: _dz._fst,
                    i17rs: $i17rs,
                  });
                  hf.udtDz(_i1z2z, _dz2);
                  _udtI1z2s();
                },
              },
            })
          ]
        },
        {
          boxStlz: a(`f/0.5 fd/rec`),
          oClds: [ // 残数
            cr.c(TextC.N, {
              key: -20,
              textz: {
//                pfx: '1',
                pfx: hf.f($i17rRz[_i1z2z.i1z2i17r1f]?.rmn) ? $i17rRz[_i1z2z.i1z2i17r1f]?.rmn : '−',
                stlz: a(`ta/r`),
              }
            })
          ]
        },
        pz.cz.bFee != false ?
        {
          boxStlz: a(`f/0.5`),
          oClds: [
            cr.c(IptC.S, { // 利用料
              key: -10,
              iptStlz: a('ta/r tb'),
              cz: {
                bEdit: false,
                iptType: 'text',
                vle: hf.cvtCmm(_i1z2z.i1z2m1100i ?? 0),
              },
            }),
            cr.c(TextC.N, {
              key: -20,
              textz: {
                pfx: '円',
              }
            })
          ]
        }
        : null,
        pz.cz.bEdit != false?
        {
          boxStlz: a('dw/btn f/n'),
          oClds: [
            cr.c(BoxC.N, {
              key: _nIdx,
              oClds: [
                cr.c(BtnC.N, {
                  key: -10,
//                  abtType: 'dltStfz',
                  abtType: 'dltIconz',
                  boxStlz: a(`sc/${pz.cz.clr}5`),
                  bfrIconCz: {},
                  lblCz:{},
                  pslPtyz: {
                    onPress: () => {
//                      hf.udtDz(_i1z2z, ihd.i('i1z2'));
                      hf.udtDz(_i1z2z, {
                        _dlt: 1,
                      });
                      _udtI1z2s();
                    },
                  }
                })
              ]
            })
          ]
        }
        : 
        {
          boxStlz: a('dw/0 f/n'),
          oClds: [
          ]
        }
      ]
    })
  })
  if ( pz.cz.bEdit != false ) {
    _rowCs.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              abtType: 'addStfz',
              boxStlz: a(`sc/${pz.cz.clr}5`),
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  pz.cz.i1zz.i1z2s.push({
                    i1z2i17r1f: -1,
                  });
                  _udtThis();
                },
              }
            })
          ]
        },
      ],
    });
  }

  return (
/*
    cr.c(BoxC.N, {
      key: 'IccTblI17.root',
      boxStlz: {
//        ... a('dw/50 f/n mh/a'),
        ... a('dw/60 f/n'),
        ... pz.boxStlz,
      },
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'hdrStfz',
          boxStlz: a('dw/f'),
          lineCs: _hdrs,
        }),

        cr.c(GridC.N, {
          key: -20,
          abtType: 'lineStfz',
          lineCs: _rowCs,
          msgCz: {
            textz: {
              pfx: '該当なし',
              stlz: a('mb/1'),
            }
          }
        })

      ]
    })
*/
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'cttCmnz',
      boxStlz: a(`dwx/60`),
      oClds: [
        cr.c(TblC.N, {
          key: -10,
    //      boxStlz: pz.boxStlz,
          srlCz: {
            abtType: 'cttCmnz',
          },
          hdrCz: {
            abtType: 'hdrStfz',
            lineCs: _hdrs,
            boxStlz: a(`bc/${pz.cz.clr}7`)
          },
          bdyCz: {
            abtType: 'lineStfz',
            lineCs: _rowCs,
            boxStlz: a(`bc/${pz.cz.clr}7`)
          }
        })
      ]
    })

  );
};
